import { Descriptions } from "antd";
import { useTranslation } from "react-i18next";
import { AllergenTagList } from "../../../components/AllergenTagList.tsx";
import { useRecipe } from "../RecipeContext.tsx";
import { QuantityUnitDisplay } from "../../../components/QuantityUnitDisplay.tsx";
import { formatDateTime } from "../../../utils/datetime.ts";
import { formatNumber } from "../../../utils/nutritionFormat.ts";
import { description as descriptionStyle } from "../RecipeDetailPage.styles.ts";
import { fitContent } from "../../../styles/shared.styles.ts";

export const RecipeGeneralTab = () => {
  const { t, i18n } = useTranslation();
  const { recipe, units } = useRecipe();

  return (
    <Descriptions bordered className={fitContent} column={1} size="small">
      <Descriptions.Item label={t("recipes.name")}>{recipe.name}</Descriptions.Item>
      <Descriptions.Item label={t("recipes.nameForLabel")}>{recipe.nameForLabel ?? "\u2014"}</Descriptions.Item>
      <Descriptions.Item label={t("recipes.description")}>
        {recipe.description ? <span className={descriptionStyle}>{recipe.description}</span> : "\u2014"}
      </Descriptions.Item>
      <Descriptions.Item label={t("recipes.allergens")}>
        {recipe.allergens.length === 0 ? "\u2014" : <AllergenTagList allergens={recipe.allergens} />}
      </Descriptions.Item>
      <Descriptions.Item label={t("recipes.netWeight")}>
        <QuantityUnitDisplay quantity={recipe.netWeightQuantity} unitId={recipe.netWeightUnitId} units={units} />
      </Descriptions.Item>
      <Descriptions.Item label={t("recipes.servingSize")}>
        <QuantityUnitDisplay quantity={recipe.servingSizeQuantity} unitId={recipe.servingSizeUnitId} units={units} />
      </Descriptions.Item>
      <Descriptions.Item label={t("recipes.servingsPerPackage")}>
        {recipe.servingsPerPackage != null ? formatNumber(recipe.servingsPerPackage, i18n.language) : "\u2014"}
      </Descriptions.Item>
      {recipe.storageRequirements != null ? (
        <Descriptions.Item label={t("recipes.storageRequirements")}>
          <span className={descriptionStyle}>{recipe.storageRequirements}</span>
        </Descriptions.Item>
      ) : null}
      <Descriptions.Item label={t("recipes.createdAt")}>
        {formatDateTime(recipe.createdAt, i18n.language)}
      </Descriptions.Item>
      <Descriptions.Item label={t("common.createdBy")}>{recipe.createdBy.name}</Descriptions.Item>
      <Descriptions.Item label={t("recipes.updatedAt")}>
        {formatDateTime(recipe.updatedAt, i18n.language)}
      </Descriptions.Item>
    </Descriptions>
  );
};
